import { shallowMount } from "@vue/test-utils";
import Configuracion from "@/views/Configuracion";

jest.mock("vue-pdf-embed/dist/vue2-pdf-embed", () => ({
  __esModule: true,
  default: {
    name: "VuePdfEmbed",
    render: fn => fn("div")
  }
}));

describe("Configuracion component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Configuracion);
  });

  it("Renders del component Configuracion", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
